import {useEffect, useState} from 'react';
import { TABLES } from '../../../../../Apis/Tables';
import {TABS_USER_TYPE_MODEL} from '../Model/Models';
import { useTranslation } from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {GetAllVisitorTypes} from "../../../../../reduxToolkit/EmployeeEvents/EmployeeEventsApi";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const AttendeesTypesApp = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [selectedUserType, setSelectedUserType] = useState(TABS_USER_TYPE_MODEL.EMPLOYEE.key);
    const [bodyForExport, setBodyForExport] = useState();
    const [searchElement, setSearchElement] = useState("");
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [results, setResults] = useState(null);
    let optionTable = TABLES.USER_BY_USER_TYPE;
    const [showCreateNewVisitorModal, setShowCreateNewVisitorModal] = useState(false);
    const [modified, setModified] = useState(false);
    const { getEventSetting } = useSelector((state) => state?.EmployeeEventsSlice);


    /**
     * Handle to get all visitor types
     */
    useEffect(() => {
        dispatch(GetAllVisitorTypes());
    }, []);

    return {
        t,
        selectedUserType, setSelectedUserType,
        bodyForExport, setBodyForExport,
        searchElement, setSearchElement,
        search, setSearch,
        simpleSearch, setSimpleSearch,
        results, setResults,
        optionTable,
        showCreateNewVisitorModal, setShowCreateNewVisitorModal,
        modified, setModified,
        getEventSetting
    }

}

export default AttendeesTypesApp
